import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingDown = currentScrollPos > prevScrollPos;

      setVisible(!isScrollingDown || currentScrollPos < 10);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className={`header-container ${visible ? '' : 'header-hidden'}`}>
      <header className="header">
        <Link to="/" className="logo impact">Consistency AI</Link>
        
        <nav className="nav-links">
          <Link to="/" className={isActive('/')}>Home</Link>
          <Link to="/phase-pal" className={isActive('/phase-pal')}>Phase Pal</Link>
          <Link to="/phase-fitness" className={isActive('/phase-fitness')}>Phase Fitness</Link>
          <Link to="/team" className={isActive('/team')}>Team</Link>
          {/* <Link to="/FAQPage" className={isActive('/FAQPage')}>FAQs</Link> */}
        </nav>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        <div className="signup-section">
          <Link to="/contact" className="signup-button">Contact Us</Link>
        </div>
      </header>

      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" onClick={closeMobileMenu}>Home</Link>
        <Link to="/phase-pal" onClick={closeMobileMenu}>Phase Pal</Link>
        <Link to="/phase-fitness" onClick={closeMobileMenu}>Phase Fitness</Link>
        <Link to="/team" onClick={closeMobileMenu}>Team</Link>
        {/* <Link to="/FAQPage" onClick={closeMobileMenu}>FAQs</Link> */}
      </div>
    </div>
  );
};

export default Header; 